import React from 'react';
import {
  Accordion, AccordionDetails, AccordionSummary,
  Table, TableBody, TableCell, TableHead, TableRow, Typography,
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

export interface EditHistoryRow {
  editSeq: number;
  editedAt: string;
  editReason: string;
  summary: string;
}

interface EditHistoryPanelProps {
  title: string;
  rows: EditHistoryRow[];
}

function formatDateTime(iso: string): string {
  if (!iso) return '-';
  try {
    return new Date(iso).toLocaleString();
  } catch {
    return iso;
  }
}

export const EditHistoryPanel: React.FC<EditHistoryPanelProps> = ({ title, rows }) => {
  if (rows.length === 0) return null;

  return (
    <Accordion sx={{ mt: 3 }} defaultExpanded={false}>
      <AccordionSummary expandIcon={<ExpandMoreIcon />}>
        <Typography variant="h6">{title}</Typography>
      </AccordionSummary>
      <AccordionDetails sx={{ p: 0 }}>
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell>#</TableCell>
              <TableCell>Edited At</TableCell>
              <TableCell>Reason</TableCell>
              <TableCell>Summary</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {rows.map(row => (
              <TableRow key={row.editSeq}>
                <TableCell>{row.editSeq}</TableCell>
                <TableCell>{formatDateTime(row.editedAt)}</TableCell>
                <TableCell>{row.editReason}</TableCell>
                <TableCell>{row.summary}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </AccordionDetails>
    </Accordion>
  );
};

export default EditHistoryPanel;
